/* eslint-disable require-jsdoc */

export function selectMenuIsActive({ menu }) {
    return menu.menuIsActive;
}

export function selectNavigationItemOpen({ menu }) {
    return menu.navigationItemOpen;
}
